import React, { useState } from 'react';
import { FlexDiv, Image } from '../../../design-system/containers';
import { TextDefault, TextLead, TextTiny } from '../../../design-system/texts';
import { Heading1 } from '../../../design-system/headings';
import { useTranslation } from 'react-i18next';
import { resourcePath } from '../../../../utils/helpers';
import { ThemedButton } from '../../../themed/themed-button/ThemedButton';
import EmailLinksAlert from '../email-links-alert';
import { browserName } from 'react-device-detect';
import DefaultTrans from '../../default-i18next-trans';

function InstallPlugin({ ui, onAction, onNextQuestion }) {
    const { t } = useTranslation('assessment');
    const [isShowingLinkAlert, setIsShowingLinkAlert] = useState(false);
    const { links } = ui;

    const handleInstallClick = () => {
        if (links && links[0] && links[0].clickActionId) {
            onAction && onAction(links[0].clickActionId);
        }
        setIsShowingLinkAlert(true);
    };

    return (
        <FlexDiv column justifyCenter alignCenter fullHeight gap={16}>
            <Image
                src={resourcePath('/static/img/assessment/plugin-missing.svg')}
                alt={t('Plugin missing')}
            />
            <Heading1 my={8}>{t('Plugin missing')}</Heading1>
            <TextLead center>
                <DefaultTrans translatedString={t('plugin_missing', { browserName })}/>
            </TextLead>
            <ThemedButton mode="black" onClick={() => handleInstallClick()} text={t('Install plugin')}>
            </ThemedButton>
            <TextDefault bold link underline onClick={() => onNextQuestion()}>
                {t('Proceed anyway')}
            </TextDefault>
            <TextTiny lighter>
                ({t('Some elements might not be displayed properly')})
            </TextTiny>
            {links && links[0] && (
                <EmailLinksAlert
                    isShowingLinkAlert={isShowingLinkAlert}
                    t={t}
                />
            )}
        </FlexDiv>
    );
}

export default InstallPlugin;
